
import { staticUrl } from '../assets';

export const SOUND_FILE = staticUrl("sound03.m4a");
// Locked to frame 66 for sound03.m4a to align perfectly with the first drop.
export const SOUND_OFFSET = 66; 
